import {
  AcceptButton,
  DocumentsUploadLink,
  Ready,
  ReadyDetails,
  ReadyDetailsAcceptance,
  ReadyDetailsInfo,
  ReadyText,
  RecommendationAccepted,
  UploadDocumentsContainer,
} from "../Recommendation.styles"
import { RecommendationAcceptedInfo } from "./RecommendationAcceptedInfo"
import { Flex } from "pages/Application/Status/shared/StyledComponents"
import { Loader, LoaderTheme } from "components/atoms/Loader"
import React from "react"
import { Recommendation } from "../types"

interface ReadyToAcceptProps {
  productTransfer: boolean
  recommendation: Recommendation
  lenderName: string
  accepting: boolean
  accepted: boolean
  hasAccepted: boolean
  acceptedVia: string
  acceptedDateTime: string
  onAcceptRecommendation: () => void
  friendlyId: string
  onUploadDocuments: () => void
}

export const ReadyToAcceptSection = ({
  productTransfer,
  recommendation,
  accepting,
  accepted,
  hasAccepted,
  onAcceptRecommendation,
  lenderName,
  onUploadDocuments,
  friendlyId,
  acceptedVia,
  acceptedDateTime,
}: ReadyToAcceptProps) => {
  return (
    <Ready>
      <ReadyDetailsInfo>
        <span>Ready to go?</span>
        <ReadyDetails>
          <ReadyDetailsAcceptance>
            {!productTransfer ? (
              <ReadyText>
                Great news, that's everything we need right now we'll confirm when your application
                has been submitted.
              </ReadyText>
            ) : (
              <Flex>
                <ReadyText>{recommendation.accept.text}</ReadyText>
                {recommendation.accept?.subText && (
                  <ReadyText>
                    {recommendation.accept.subText.replace(/\[Lender\]/g, lenderName)}
                  </ReadyText>
                )}
              </Flex>
            )}
            <div>
              {accepting ? (
                <Loader size={32} theme={LoaderTheme.Outline} />
              ) : (
                <>
                  {accepted || hasAccepted ? (
                    <RecommendationAccepted>
                      <span>Accepted</span>
                    </RecommendationAccepted>
                  ) : (
                    <>
                      <AcceptButton type="button" onClick={onAcceptRecommendation}>
                        Accept Recommendation
                      </AcceptButton>
                    </>
                  )}
                </>
              )}

              {(accepted || hasAccepted) && !accepting && (
                <RecommendationAcceptedInfo
                  acceptedDateTime={acceptedDateTime}
                  acceptedVia={acceptedVia}
                />
              )}
            </div>
          </ReadyDetailsAcceptance>
          <div>
            By accepting, you are giving consent for your selected lender to conduct a hard credit
            check (this does not apply if you are transferring to a new product with your existing
            lender)
          </div>
        </ReadyDetails>
      </ReadyDetailsInfo>

      {hasAccepted && !accepting && !productTransfer && (
        <UploadDocumentsContainer>
          <span>Great! You’re now one step closer</span>
          <div>
            <span>
              Please check we have all the correct documents for you and we'll get the wheels in
              motion.
            </span>
            <DocumentsUploadLink
              href={`/application/${friendlyId}/documents`}
              onClick={onUploadDocuments}
            >
              Upload Documents
            </DocumentsUploadLink>
          </div>
        </UploadDocumentsContainer>
      )}
    </Ready>
  )
}
